const LANGUAGE_OVERRIDES: Record<string, string> = {
  'tassiobs+spanish@gmail.com': 'Spanish',
};

export const getLanguage = (email: string): string =>
  LANGUAGE_OVERRIDES[email] ?? 'English';

export const getMicLocale = (email: string): string =>
  getLanguage(email) === 'Spanish' ? 'es-ES' : 'en-US';
